import { useId } from 'react';
import {
  MARK_BACK, MARK_BODY, MARK_EAR, MARK_FRONT_TRANSFORM, WORD_AI, WORD_MAIN, LOCKUP,
} from '../brand/logoPaths';

// Mark: two fanned hole cards. The front card's clipped corner is the accent.
// Colours come from the theme tokens (text colour + signal green).
function MarkShapes({ maskId }) {
  const b = MARK_BACK;
  return (
    <>
      <defs>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="-8" y="-8" width="80" height="80">
          <rect x="-8" y="-8" width="80" height="80" fill="#fff" />
          <g transform={MARK_FRONT_TRANSFORM}>
            <path d={MARK_BODY} fill="#000" stroke="#000" strokeWidth="7" strokeLinejoin="round" />
          </g>
        </mask>
      </defs>
      <g transform="translate(2 1)">
        <rect
          x={b.x} y={b.y} width={b.w} height={b.h} rx={b.r}
          transform={`rotate(${b.rot} ${b.cx} ${b.cy})`}
          fill="currentColor" mask={`url(#${maskId})`}
        />
        <g transform={MARK_FRONT_TRANSFORM}>
          <path d={MARK_BODY} fill="currentColor" />
          <path d={MARK_EAR} className="fill-pn-signal" />
        </g>
      </g>
    </>
  );
}

export function LogoMark({ className = 'h-8 w-8', title = 'PokerNow AI' }) {
  const maskId = `pn-mark-${useId().replace(/:/g, '')}`;
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label={title}>
      <MarkShapes maskId={maskId} />
    </svg>
  );
}

export default function Logo({ className = 'h-7 w-auto', title = 'PokerNow AI' }) {
  const maskId = `pn-logo-${useId().replace(/:/g, '')}`;
  return (
    <svg viewBox={`0 0 ${LOCKUP.width} 64`} className={className} role="img" aria-label={title}>
      <MarkShapes maskId={maskId} />
      <g transform={`translate(${LOCKUP.wordX} ${LOCKUP.baseline})`}>
        <path d={WORD_MAIN} fill="currentColor" />
        <path d={WORD_AI} className="fill-pn-signal" />
      </g>
    </svg>
  );
}
